import { render } from "./PageNotFound.vue?vue&type=template&id=6cddb6f6&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6cddb6f6"

export default script